import BaseModel from './base.model';

export default class Role extends BaseModel {
}
